// extracted by mini-css-extract-plugin
export default {"roles":"style_roles__2uzmm"};